// backGroundGenerator.js
var BackGroundGenerator = pc.createScript('backGroundGenerator');

BackGroundGenerator.attributes.add('noiseMapsF', {type: 'asset', assetType: 'texture', array:true});
BackGroundGenerator.attributes.add('noiseMapsB', {type: 'asset', assetType: 'texture', array:true});
BackGroundGenerator.attributes.add('noiseMapsC', {type: 'asset', assetType: 'texture', array:true});
BackGroundGenerator.attributes.add('colorGrad', {type: 'curve', color: 'rgba'});
BackGroundGenerator.attributes.add('colorGradB', {type: 'curve', color: 'rgba'});
BackGroundGenerator.attributes.add('colorGradC', {type: 'curve', color: 'rgba'});

// initialize code called once per entity
BackGroundGenerator.prototype.initialize = function() {

    this.app.on('seeder:reset', this.calcBG,this);
    
    this.systemName = this.app.root.children[0].script.planetInfoGenerator.systemName;

    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = 0.0;
    this.randomize = 0.0;
    
    this.starSphere = this.entity.children[0].children[0];
    this.gasCloudSphere_1 = this.entity.children[1];
    this.gasCloudSphere_2 = this.entity.children[2];
    this.gasCloudSphere_3 = this.entity.children[3];
    this.starSphereMat = this.starSphere.model.meshInstances[0].material;
    this.gasCloudMat_1 = this.gasCloudSphere_1.model.meshInstances[0].material;
    this.gasCloudMat_2 = this.gasCloudSphere_2.model.meshInstances[0].material;
    this.gasCloudMat_3 = this.gasCloudSphere_3.model.meshInstances[0].material;
    this.randomColor_1 = null;
    this.randomColor_2 = null;
    this.randomColor_3 = null;
    this.nLength = this.noiseMapsF.length;
    
};

BackGroundGenerator.prototype.calcBG = function() {
    
    this.systemName = this.app.root.children[0].script.planetInfoGenerator.systemName;
   // console.log(this.systemName);
    
    this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.systemName);
    var rot = Math.floor(this.randomize()*360);
    this.starSphere.setLocalEulerAngles(rot, rot, rot);
    var cg = this.colorGrad;
    var cr_1 = this.randomize();
    var cr_2 = 0;
    var cr_3 = 0;
    if(cr_1 < 0.25){
        cr_3 = 1 - (0.25 - cr_1);
        cr_2 = cr_1 + 0.25;
    } else if (cr_1 > 0.26 && cr_1 < 0.74){
        cr_2 = cr_1 - 0.25;
        cr_3 = cr_1 + 0.25;
    } else if (cr_1 > 0.75){
        cr_2 = 0.25 - (1 - cr_1);
        cr_3 = cr_1 - 0.25;
        
    }


    
    var emsv1 = this.noiseMapsF[Math.floor(this.randomize() * this.nLength)];
    var emsv2 = this.noiseMapsB[Math.floor(this.randomize() * this.nLength)];
    var emsv3 = this.noiseMapsC[Math.floor(this.randomize() * this.nLength)];

    this.randomColor_1 = new pc.Color(cg.get(0).value(cr_1), cg.get(1).value(cr_1), cg.get(2).value(cr_1));
    this.randomColor_2 = new pc.Color(cg.get(0).value(cr_2), cg.get(1).value(cr_2), cg.get(2).value(cr_2));
    this.randomColor_3 = new pc.Color(cg.get(0).value(cr_3), cg.get(1).value(cr_3), cg.get(2).value(cr_3));

    
   // console.info(this.gasCloudMat_1);
    
    this.gasCloudMat_1.emissive = this.randomColor_1;
    this.gasCloudMat_2.emissive = this.randomColor_2;
    this.gasCloudMat_3.emissive = this.randomColor_3;
        
    // console.log('cr_1: ' + this.randomColor_1);
    // console.log('cr_2: ' + this.randomColor_2);
    // console.log('cr_3: ' + this.randomColor_3);
    // console.log('....................................');
    
    this.gasCloudMat_1.emissiveMap = emsv1.resource; //console.log('gm_f: ' + this.gasCloudMat_1.emissiveMap.name);
    this.gasCloudMat_2.emissiveMap = emsv2.resource; //console.log('gm_b: ' + this.gasCloudMat_2.emissiveMap.name);
    this.gasCloudMat_3.emissiveMap = emsv3.resource; //console.log('gm_c: ' + emsv3.resource.name);
    //console.log('mat1: ' + this.gasCloudMat_1.emissiveMap.name + ' mat2: ' + this.gasCloudMat_2.emissiveMap.name + ' mat3: ' + this.gasCloudMat_3.emissiveMap.name);
    //console.log(emsv1.name + ' ');
    this.gasCloudMat_1.update();
    this.gasCloudMat_2.update();
    this.gasCloudMat_3.update();
     // console.log('gcMat1: '+ this.gasCloudMat_1.emissiveMap.name);
     // console.log('gcClr1: ' + this.gasCloudMat_1.emissive);
     // console.log('gcMat2: '+ this.gasCloudMat_2.emissiveMap.name);
     // console.log('gcClr2: ' + this.gasCloudMat_2.emissive);
     // console.log('gcMat3: '+ this.gasCloudMat_3.emissiveMap.name);
     // console.log('gcClr3: ' + this.gasCloudMat_3.emissive);
    
};

// update code called every frame
BackGroundGenerator.prototype.update = function(dt) {
//     if (this.app.keyboard.wasReleased(pc.KEY_SPACE)) {
        
//     }
};

// swap method called for script hot-reloading
// inherit your script state here
// BackGroundGenerator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

